// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Color Variables */
:root {
    --primary-color: #C9CED5;
    --secondary-color: #666666;
    --background-color: #F8F8F8;
    --text-color: #344049;
    --error-color: #FE6A6A;
    --warning-color: #f39c12;
    --success-color: #27ae60;
  }
  `, "",{"version":3,"sources":["webpack://./src/variables.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;IACI,wBAAwB;IACxB,0BAA0B;IAC1B,2BAA2B;IAC3B,qBAAqB;IACrB,sBAAsB;IACtB,wBAAwB;IACxB,wBAAwB;EAC1B","sourcesContent":["/* Color Variables */\n:root {\n    --primary-color: #C9CED5;\n    --secondary-color: #666666;\n    --background-color: #F8F8F8;\n    --text-color: #344049;\n    --error-color: #FE6A6A;\n    --warning-color: #f39c12;\n    --success-color: #27ae60;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
